/* eslint-disable import/no-named-as-default-member */
import React from 'react'
import { connect } from 'react-redux'
import * as Semantic from 'semantic-ui-react'
import _ from 'lodash'
import firebase from '../../config/firebase'

import utils from '../../utils'

import RestaurantActions from '../../reducers/restaurantReducer'
import MenuActions from '../../reducers/menuReducer'
import TagActions from '../../reducers/tagReducer'
import ItemActions from '../../reducers/itemReducer'
import ItemOptionActions from '../../reducers/itemOptionReducer'
import DynamicFeeActions from '../../reducers/dynamicFeeReducer'
import UnavailableItemActions from '../../reducers/unavailableItemReducer'
import CrossSellItemActions from '../../reducers/crossSellItemReducer'

import StoreSummary from '../../components/restaurants/views/storeSummary'
import BranchesSummary from '../../components/restaurants/views/branchesSummary'
import ItemSearch from '../../components/restaurants/views/itemSearch'
import ItemList from '../../components/restaurants/views/itemsList'
import ItemOptionsList from '../../components/restaurants/views/itemOptionsList'
import UnavailableItemList from '../../components/restaurants/views/unavailableItemList'
import BranchOrders from '../../components/restaurants/views/branchOrders'
import CrossSellItemsList from '../../components/restaurants/views/CrossSellItemsList'

class RestaurantDetail extends React.PureComponent {
  constructor() {
    super()

    this.state = {
      eMenuConfigs: null,
    }

    window.scrollTo(0, 0)
  }

  componentDidMount() {
    const { menusLoaded, tagsLoaded, match, restaurants, getUnavailableItems, getCrossSellItems } = this.props
    const {
      fetchTags,
      fetchMenus,
      fetchStore,
      fetchItems,
      syncItemOptions,
      fetchDynamicFees,
      fetchStores,
    } = this.props

    const { id: storeId } = match.params

    if (!menusLoaded) fetchMenus()
    if (!tagsLoaded) fetchTags()

    if (_.size(restaurants) <= 1) {
      fetchStores()
    } else {
      fetchStore(storeId)
    }

    fetchItems(storeId)
    fetchDynamicFees()
    syncItemOptions(storeId)
    getUnavailableItems(storeId)
    getCrossSellItems(storeId)
    this.getEMenuConfigs()
  }

  componentWillUnmount() {
    const { unsyncItemOptions } = this.props

    unsyncItemOptions()
  }

  getEMenuConfigs = () => {
    this.subscription = firebase.database().ref('/configs/e_menu')
    this.subscription.on('value', (snapshot) => {
      const eMenuConfigs = snapshot.val() || false

      this.setState({ eMenuConfigs })
    })
  }

  getUnavailableItemsData = () => {
    const { match, unavailableItems } = this.props
    const merchantKey = match.params.id

    return _.reduce(
      unavailableItems[merchantKey] || {},
      (result, item, itemKey) => {
        const unavailableItem = { ...item, doc_id: itemKey }

        result.merchantUnavailableItems.push(unavailableItem)

        if (!result.branchesHoldUnavailableItem.includes(item.branch_id)) {
          result.branchesHoldUnavailableItem.push(item.branch_id)
        }

        // eslint-disable-next-line no-param-reassign
        result.unavailableItemsByBranch[item.branch_id] =
          result.unavailableItemsByBranch[item.branch_id] || []
        result.unavailableItemsByBranch[item.branch_id].push(unavailableItem)

        return result
      },
      { branchesHoldUnavailableItem: [], merchantUnavailableItems: [], unavailableItemsByBranch: {} }
    )
  }

  renderRestaurantDetail = () => {
    const { eMenuConfigs } = this.state
    const { match, restaurants, tags, menus, loading, fetchStore, regions, user, history } = this.props
    const store = restaurants[match.params.id] || {}

    return (
      <Semantic.Tab.Pane
        color="black"
        attached={false}
        style={{ height: 'calc(100vh - 180px)', overflow: 'auto' }}
        className="store-summary"
      >
        <StoreSummary
          user={user}
          regions={regions}
          store={store}
          tags={tags}
          menus={menus}
          storeId={match.params.id}
          fetchStore={() => fetchStore(match.params.id)}
          loading={loading}
          history={history}
          eMenuConfigs={eMenuConfigs}
        />
      </Semantic.Tab.Pane>
    )
  }

  renderRestaurantBranches = () => {
    const { match, restaurants, loading, fetchStore } = this.props
    const store = restaurants[match.params.id] || {}

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <BranchesSummary
          branches={store.branches || {}}
          storeId={match.params.id}
          fetchStore={() => fetchStore(match.params.id)}
          loading={loading}
        />
      </Semantic.Tab.Pane>
    )
  }

  renderRestaurantItems = () => {
    const { match, restaurants, items, loading, tags, fetchItems } = this.props
    const storeItems = items[match.params.id] || {}
    const storeData = restaurants[match.params.id] || {}

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <ItemList
          storeData={storeData}
          items={storeItems}
          storeId={match.params.id}
          loading={loading}
          tags={tags}
          fetchItems={() => fetchItems(match.params.id)}
        />
      </Semantic.Tab.Pane>
    )
  }

  renderItemOptions = () => {
    const { match, loading, itemOptions } = this.props

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <ItemOptionsList storeId={match.params.id} loading={loading} itemOptions={itemOptions} />
      </Semantic.Tab.Pane>
    )
  }

  renderUnavailableItem = () => {
    const { match, loading, restaurants, items, getUnavailableItems, setUnavailableItem } = this.props

    const storeId = match.params.id
    const store = restaurants[storeId] || {}
    const storeItems = items[storeId] || {}

    const { branches } = store
    const unavailableItemData = this.getUnavailableItemsData()

    const allBranches = _.reduce(
      branches,
      (result, branch, branchId) => {
        if (!unavailableItemData.branchesHoldUnavailableItem.includes(branchId)) {
          result.noUnavailableItemBranches.push({ ...branch, key: branchId })
        }
        result.allBranches.push({ ...branch, key: branchId })

        return result
    }, { noUnavailableItemBranches: [], allBranches: [] })

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <UnavailableItemList
          loading={loading}
          storeId={storeId}
          items={storeItems}
          unavailableItemData={unavailableItemData}
          allBranches={allBranches}
          merchant={store}
          setUnavailableItem={setUnavailableItem}
          getUnavailableItems={getUnavailableItems}
        />
      </Semantic.Tab.Pane>
    )
  }

  renderCrossSellItems = () => {
    const { match, loading, restaurants, items, crossSellItems, getCrossSellItems, setCrossSellItems } = this.props

    const merchantId = match.params.id
    const store = restaurants[merchantId] || {}
    const storeItems = items[merchantId] || {}

    let { branches = [] } = store
    branches = Object.entries(branches).map(([id, branch]) => ({ ...branch, id })) || []

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <CrossSellItemsList
          loading={loading}
          items={storeItems}
          branches={branches}
          merchantId={merchantId}
          crossSellItems={crossSellItems}
          setCrossSellItems={setCrossSellItems}
          getCrossSellItems={getCrossSellItems}
        />
      </Semantic.Tab.Pane>
    )
  }

  renderSearchItem = () => {
    const { match, restaurants, loading, tags } = this.props

    const storeData = restaurants[match.params.id] || {}

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ minHeight: 'calc(100vh - 180px)' }}>
        <ItemSearch storeData={storeData} storeId={match.params.id} loading={loading} tags={tags} />
      </Semantic.Tab.Pane>
    )
  }

  renderBranchOrder = () => {
    const { match, loading, restaurants } = this.props
    const merchantKey = match.params.id
    const merchant = restaurants[merchantKey] || {}

    return (
      <Semantic.Tab.Pane color="black" attached={false} style={{ height: 'calc(100vh - 180px)' }}>
        <BranchOrders loading={loading} merchantKey={merchantKey} merchant={merchant} />
      </Semantic.Tab.Pane>
    )
  }

  onTabChange = index => {
    const { history, match } = this.props
    const merchantKey = match.params.id
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/restaurants/detail/${merchantKey}${queryString}`)
  }

  tabPanes = () => {
    const { roles, user } = this.props

    const panes = {
      restaurant: {
        menuItem: 'Restaurant',
        render: this.renderRestaurantDetail,
      },
      branches: {
        menuItem: 'Branches',
        render: this.renderRestaurantBranches,
      },
      item: {
        menuItem: 'Items',
        render: this.renderRestaurantItems,
      },
      'item-options': {
        menuItem: 'Item Options',
        render: this.renderItemOptions,
      },
      'unavailable-items': {
        menuItem: 'Unavailable Items',
        render: this.renderUnavailableItem,
      },
      "cross-sell-items": {
        menuItem: 'Cross-sell Items',
        render: this.renderCrossSellItems,
      },
      'search-item': {
        menuItem: 'Search Items',
        render: this.renderSearchItem,
      },
    }

    if (roles[user.role] && roles[user.role].access.includes('restaurant_orders')) {
      panes.orders = {
        menuItem: 'Orders',
        render: this.renderBranchOrder,
      }
    }

    return panes
  }

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'restaurant'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Semantic.Grid>
          <Semantic.Grid.Column width="16">
            <Semantic.Tab
              activeIndex={tabIndex}
              menu={{ pointing: true }}
              panes={Object.values(this.tabPanes())}
              onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
            />
          </Semantic.Grid.Column>
        </Semantic.Grid>
      </div>
    )
  }
}

const mapState = ({ items, restaurants, tags, menus, itemOptions, auth, rolePermission, dynamicFees, regions, unavailableItem, crossSellItems }) => ({
  tags: tags.data,
  items: items.data,
  menus: menus.data,
  loading:
    restaurants.loading ||
    items.loading ||
    menus.loading ||
    tags.loading ||
    itemOptions.loading ||
    dynamicFees.dynamicFeeLoading ||
    unavailableItem.loading ||
    crossSellItems.loading,
  menusLoaded: menus.loaded,
  tagsLoaded: tags.loaded,
  restaurants: restaurants.data,
  itemOptions: itemOptions.data,
  user: auth.data,
  roles: rolePermission.roles,
  regions: regions.data,
  unavailableItems: unavailableItem.data,
  crossSellItems: crossSellItems.data,
})

const mapDispatch = {
  fetchTags: TagActions.fetchTagsRequest,
  fetchMenus: MenuActions.fetchMenusRequest,
  fetchStore: RestaurantActions.fetchRestaurantRequest,
  fetchStores: RestaurantActions.fetchRestaurantsRequest,
  fetchItems: ItemActions.fetchItemsByRestaurant,
  fetchDynamicFees: DynamicFeeActions.syncDynamicFees,
  syncItemOptions: ItemOptionActions.getItemOptions,
  unsyncItemOptions: ItemOptionActions.getItemOptionsDisconnected,
  getUnavailableItems: UnavailableItemActions.getUnavailableItems,
  setUnavailableItem: UnavailableItemActions.setUnavailableItem,
  getCrossSellItems: CrossSellItemActions.getCrossSellItems,
  setCrossSellItems: CrossSellItemActions.setCrossSellItems,
}

export default connect(
  mapState,
  mapDispatch
)(RestaurantDetail)



// WEBPACK FOOTER //
// ./src/containers/restaurants/detail.js